<template>
  <div class="w-full flex flex-col gap-4 p-4 border border-border-normal transition-colors hover:border-border-hover bg-white cursor-pointer" 
  style="border-radius: 20px;" @click="$emit('selected')">
    <div class="w-full flex items-center justify-between">
      <!-- Payout -->
      <div class="flex items-center gap-0.5 pl-1 py-1 pr-2 rounded-md" 
      style="color: #B38600; background-color: rgba(255, 208, 24, 0.04);">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 28 28" fill="none">
          <path d="M14 23.45C19.2192 23.45 23.45 19.2191 23.45 14C23.45 8.7809 19.2192 4.54999 14 4.54999C8.78096 4.54999 4.55005 8.7809 4.55005 14C4.55005 19.2191 8.78096 23.45 14 23.45Z" stroke="#B38600" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 9.27501V8.22501M14 18.725V19.775M16.1 10.85C15.05 8.75001 11.375 9.32995 11.375 11.6667C11.375 14.708 16.625 13.2786 16.625 16.2532C16.625 18.6103 12.425 19.25 11.375 17.15" stroke="#B38600" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <BaseText type="label" size="md">
          {{ bountyInfo.payout.toLocaleString() }}
        </BaseText>
      </div>
      <div class="flex items-center gap-2">
        <!-- Due Date -->
        <div class="flex items-center gap-1 px-2 py-1 rounded-lg bg-neutral-10">
          <DueDateIcon class="text-icon-normal" />
          <BaseText type="label" size="sm" class="text-text-normal">
            Due {{ formattedDueDate }}
          </BaseText>
        </div>
        <!-- Status -->
        <div class="flex items-center gap-1.5 px-2 py-1 rounded-lg bg-secondary-green-10">
          <div class="w-1.5 h-1.5 rounded-full bg-secondary-green-200" />
          <BaseText type="label" size="sm" class="text-secondary-green-200">
            Open
          </BaseText>
        </div>
      </div>
    </div>
    <!-- divider -->
    <div class="w-full h-0 border-t border-border-normal" />
    <!-- Info Body -->
    <div class="w-full flex flex-col gap-1 text-left">
      <BaseText type="label" size="sm" class="text-text-muted">
        {{ bountyInfo.title }}
      </BaseText>
      <BaseText type="body" size="sm" class="text-text-normal">
        {{ bountyInfo.description }}
      </BaseText>
    </div>
    <!-- Creator Info -->
    <div class="flex items-center">
      <img :src="bountyInfo.creator.avatar" class="w-5 h-5 rounded-full" />
      <BaseText type="label" size="sm" class="text-text-muted ml-3">
        {{ bountyInfo.creator.name }}
      </BaseText>
      <BaseText type="body" size="sm" class="text-text-normal ml-2">
        {{ bountyInfo.creator.handle }}
      </BaseText>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import BountyPayoutIcon from '../globals/Icons/BountyPayoutIcon.vue'
import DueDateIcon from '../globals/Icons/DueDateIcon.vue'

export default {
  name: 'BountyCard',
  components: {
    BountyPayoutIcon,
    DueDateIcon
  },
  props: {
    bountyInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedDueDate () {
      return moment(this.bountyInfo.dueDate).format('MMMM DD, YYYY')
    }
  }
}
</script>

<style scoped></style>